import { palette } from 'app_previous/styles/colors';
import styled, { css } from 'styled-components';
import VideoPlayer from './VideoPlayer/VideoPlayer';
import { layout } from 'app_previous/styles/layout';

export const OverlayVideoBackground = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 110;
  background: #0b0b0b;
  opacity: 0.8;
  overflow: hidden;
  height: 100vh;
  width: 100vw;
  max-width: 100vw !important; // used !important to make sure that the background will fill the whole screen
`;

interface OverlayVideoContentProps {
  verticalDesign?: boolean;
}

export const OverlayVideoContent = styled.div<OverlayVideoContentProps>`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 120;
  height: 56.25vw;
  max-height: 56.25vh;
  max-width: 100vw;

  ${({ verticalDesign }) =>
    !verticalDesign
      ? ''
      : css`
          height: 75vh;
          max-height: 75vh;
        `}
`;

export const CloseButtonContainer = styled.div`
  position: absolute;
  right: 0px;
  top: -32px;
  color: ${palette.white};
  font-size: 28px;
  z-index: 110;
  cursor: pointer;
  opacity: 0.8;

  &:hover {
    opacity: 1;
  }
`;

export const OverlayVideoPlayer = styled(VideoPlayer)`
  max-height: 100%;
  max-width: calc(100vw - 8px);
`;

interface WistiaPlayerContainerProps {
  isVertical?: boolean;
}

export const WistiaPlayerContainer = styled.div<WistiaPlayerContainerProps>`
  ${({ isVertical }) => (isVertical ? 'width: min(400px, 100vw);' : 'width: min(900px, 100vw);')}
  position: relative;

  @media all and (max-width: ${layout.xxs}) {
    ${({ isVertical }) => isVertical && 'width: 90vw;'}
  }
`;
